import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';
import { remove, toggleRemoveModal } from 'project/ducks/creatives';

const mapStateToProps = ({ project: { creatives } }) => {
  const creative = creatives.removingCreative || {};
  return {
    dialogVisible: creatives.showingRemoveModal,
    dialogHeader: 'Remove Creative',
    dialogTitle: `Are you sure you want to remove ${creative.username}?`,
    dialogMessage: `If you remove them from your project, ${creative.username} will be prevented from participating in this project and all their entries will be eliminated.`,
    primaryActionText: 'Yes, remove',
    secondaryActionText: 'Cancel'
  };
};

const mapDispatchToProps = (dispatch, { atEntries, location }) => {
  return bindActionCreators({
    submitAction: partial(remove, atEntries? location.query : null),
    toggleDialog: toggleRemoveModal
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog));



// WEBPACK FOOTER //
// ./entries/containers/remove_creative_modal.js